import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import TypographyAtom from '../../atoms/typography/typography'
import { Container, ImageWrapper } from './ArticleAuthor.styled'
import TextHeader from '../TextHeader/TextHeader'

function ArticleAuthor({ authorName, authorPhoto, authorBiography }) {
  return (
    <Container className={`flex ${authorPhoto ? 'col-lg-10' : 'col-xs-12'}`}>
      {authorPhoto && (
        <div className="author-avatar-sm">
          <ImageWrapper>
            <GatsbyImage image={authorPhoto} alt={authorName} />
          </ImageWrapper>
        </div>
      )}

      <div className="author-info-sm">
        <div className="margin-xs-16 margin-md-24">
          <TextHeader title={authorName} subtitle="Written By" authorTitle reverse />
        </div>
        <TypographyAtom type="P" weight="Regular" copy={authorBiography} />
      </div>
    </Container>
  )
}

export default ArticleAuthor
